module.exports = __webpack_public_path__ + "images/cross-black770a75644ef951dced2238f448069385.svg";